export default {"src":"/_next/static/media/google-reviews.fce08971.svg","height":46,"width":182};